import React from 'react';
import ReactDOM from 'react-dom';
import RouteHandler from './RouteHandler';

ReactDOM.render(
    <RouteHandler />,
  document.getElementById('root')
);

